import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';
import { SalesCartPagelayoutHandler } from './sales-cart-page-layout.handler';
import { SalesCartSummaryComponent } from './sales-cart-summary/sales-cart-summary.component';
import { SalesCartEmptyComponent } from './sales-cart-empty/sales-cart-empty.component';
import { SalesCartRfqSummaryComponent } from './sales-cart-rfq-summary/sales-cart-rfq-summary.component';

@NgModule({
  declarations: [],
  imports: [CommonModule,
    ConfigModule.withConfig({
            cmsComponents: {
                salesCartEmptyComponent: {
                    component: SalesCartEmptyComponent,
                },
                salesCartSummaryComponent: {
                    component: SalesCartSummaryComponent
                },
                RfqCartFlexComponent: {
                    component: SalesCartRfqSummaryComponent
                }
            },
        } as CmsConfig),
        SalesCartEmptyComponent,
        SalesCartSummaryComponent,
        SalesCartRfqSummaryComponent
  ],
    providers: [
        {
            provide: PAGE_LAYOUT_HANDLER,
            useExisting: SalesCartPagelayoutHandler,
            multi: true,
        },
    ],
})
export class KnBrSalesCartModule {}
